import { useLayoutEffect } from "react";

const setVisibility = show => (show ? "visible" : "hidden");

const useDropDownPositioning = (showDropdown, parentId, setDropDownCustomStyle, dropDownId, value, inputId) => {
  useLayoutEffect(() => {
    let defaultView = true;
    if (parentId) {
      const dropDown = document.getElementById(`input${dropDownId}`);
      const input = document.getElementById(inputId);
      const parent = document.getElementById(parentId);
      const desc = document.getElementById(`desc${dropDownId}`);
      let descValue = 0;
      if (dropDown && input && parent) {
        const dropDownRect = dropDown.getBoundingClientRect();
        const inputRect = input.getBoundingClientRect();
        const parentRect = parent.getBoundingClientRect();
        if (
          inputRect.y + inputRect.height + dropDownRect.height + 20 > parentRect.y + parentRect.height &&
          dropDownRect.height < inputRect.y - parentRect.y
        ) {
          const { height } = dropDownRect;
          defaultView = false;
          setDropDownCustomStyle({ top: (10 + height) * -1, visibility: setVisibility(showDropdown) });
        }
        if (desc) {
          const descRect = desc.getBoundingClientRect();
          descValue = descRect.width + 10;
        }
        if (dropDownRect.width + inputRect.x + 2 > parentRect.x + parentRect.width) {
          defaultView = false;
          setDropDownCustomStyle({ right: 0 + descValue, visibility: setVisibility(showDropdown) });
        }
        if (dropDownRect.width > parentRect.width) {
          setDropDownCustomStyle({ width: "100%", visibility: setVisibility(showDropdown) });
        }
      }
    }
    if (defaultView) {
      setDropDownCustomStyle({ visibility: setVisibility(showDropdown) });
    }
  }, [showDropdown, parentId, setDropDownCustomStyle, dropDownId, value, inputId]);

  return null;
};

useDropDownPositioning.displayName = "useDropDownPositioning";

export default useDropDownPositioning;
